module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0704.b4d0e1b8.jpg";